import React, { Fragment } from 'react';

import { Bar } from '@visx/shape';

import { CHART_HOVER_TRANSITION, COLOR_WHEEL } from '../../constants';
import { BarChartData } from '../../types';

export const MultiBarEntry = ({
  bars,
  combinedBarWidth,
  handleMouseEnterSvg,
  handleMouseOutSvg,
  handleMouseOverSvg,
  innerHeight,
  itemOpacity,
  resource,
  xScale,
  yScale,
}: {
  bars: [string, number][];
  combinedBarWidth: number;
  handleMouseEnterSvg: (
    event: React.MouseEvent<SVGSVGElement>,
    resource: BarChartData[number],
  ) => void;
  handleMouseOutSvg: () => void;
  handleMouseOverSvg: (
    event: React.MouseEvent<SVGSVGElement>,
    resource: BarChartData[number],
  ) => void;
  innerHeight: number;
  itemOpacity: number;
  resource: BarChartData[number];
  xScale: any;
  yScale: any;
}) => {
  const totalBars = bars.length;
  const GAP_BETWEEN_BARS = 4;
  const totalGapWidth = (totalBars - 1) * GAP_BETWEEN_BARS;
  const subBarWidth = (combinedBarWidth - totalGapWidth) / totalBars;

  return (
    <>
      {bars.map(([key, value], index) => {
        const barX = (xScale(resource.name) || 0) + index * (subBarWidth + GAP_BETWEEN_BARS);
        const barHeight = Math.max(innerHeight - yScale(Number(value)), 2);

        return (
          <Fragment key={`bar-${resource.name}-${key}`}>
            <Bar
              fill={COLOR_WHEEL[index % COLOR_WHEEL.length]}
              fillOpacity={itemOpacity}
              height={barHeight}
              onMouseEnter={(event) =>
                handleMouseEnterSvg(event as unknown as React.MouseEvent<SVGSVGElement>, {
                  color: COLOR_WHEEL[index % COLOR_WHEEL.length],
                  name: key ?? resource.name,
                  value: Number(value),
                })
              }
              onMouseMove={(event) =>
                handleMouseOverSvg(event as unknown as React.MouseEvent<SVGSVGElement>, {
                  color: COLOR_WHEEL[index % COLOR_WHEEL.length],
                  name: key ?? resource.name,
                  value: Number(value),
                })
              }
              onMouseOut={handleMouseOutSvg}
              rx={2}
              style={{
                cursor: 'pointer',
                transition: CHART_HOVER_TRANSITION,
              }}
              width={subBarWidth}
              x={barX}
              y={innerHeight - barHeight}
            />
          </Fragment>
        );
      })}
    </>
  );
};
